<template>
  <div class="tab-container">
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <template v-if="table_expiring_items.length">
        <app-cells><h2 class="title">Expiring</h2></app-cells>
        <table-licenses-expiring
          :table-items="table_expiring_items"
          :date-format="dateFormat"
          :download-file="downloadFile"
        />
      </template>
      <app-cells><h2 class="title">Licenses</h2></app-cells>
      <app-cells>
        <app-button @click.native="onOpenCreateModal(null)">Add license</app-button>
        <app-filters
          v-model="status_filter"
          :filters="status_filters"
          name="filterStatus"
          @change="onChangeFilter"
        />
      </app-cells>
      <table-licenses
        @clickPagination="onClickPagination"
        @openCreateModal="onOpenCreateModal"
        @showDeleteModal="onShowDeleteModal"
        :table-items="table_licenses_items"
        :table-preloader="table_preloader"
        :pagination="pagination"
        :date-format="dateFormat"
        :download-file="downloadFile"
      />
    </template>
    <modal
      name="create-modal"
      :width="700"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      class="modal-not-overflow"
    >
      <div class="popup">
        <button @click="$modal.hide('create-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ license_to_action ? 'Update' : 'Add' }} license</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-grid>
              <template #item-1>
                <app-form-group label="Number" label-for="license_number" required>
                  <app-input
                    @change.native="$v.form.number.$touch()"
                    v-model="form.number"
                    id="license_number"
                    placeholder="Number of license"
                    name="license_number"
                    :error="$v.form.number.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.number.$dirty && !$v.form.number.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Group" required>
                  <app-select
                    @input="onGroupSelected"
                    v-model="form.group"
                    :options="license_groups_options"
                    :clearable="false"
                    placeholder="Group"
                    :error="$v.form.group.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.group.$dirty && !$v.form.group.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Type" required>
                  <app-select
                    v-model="form.type"
                    :options="form.group?.types"
                    :clearable="false"
                    :placeholder="form.group ? 'Type' : 'Please, select a group first'"
                    :readonly="!form.group"
                    :error="$v.form.type.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.type.$dirty && !$v.form.type.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Supplier" required>
                  <app-select
                    @search="onSupplierSearch"
                    v-model="form.supplier"
                    :options="supplier_options"
                    :clearable="false"
                    label="trade_name"
                    placeholder="Supplier"
                    :error="$v.form.supplier.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #item-2>
                <app-form-group label="License date" required>
                  <app-date-picker
                    v-model="form.start"
                    placeholder="Date"
                    :error="$v.form.start.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.start.$dirty && !$v.form.start.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Expire date" required>
                  <app-date-picker
                    v-model="form.finish"
                    placeholder="Date"
                    :error="$v.form.finish.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.finish.$dirty && !$v.form.finish.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Amount paid" label-for="amount_paid" required>
                  <app-input
                    @change.native="$v.form.amount_paid.$touch()"
                    v-model.number="form.amount_paid"
                    id="amount_paid"
                    placeholder="0"
                    name="amount_paid"
                    type="number"
                    :error="$v.form.amount_paid.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.amount_paid.$dirty && !$v.form.amount_paid.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Currency" required>
                  <app-select
                    v-model="form.amount_paid_currency"
                    :options="currency_options"
                    :clearable="false"
                    placeholder="Currency"
                    :error="$v.form.amount_paid_currency.$error"
                  />
                  <template #error>
                    <div v-if="$v.form.amount_paid_currency.$dirty && !$v.form.amount_paid_currency.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Attachment">
                  <app-uploader
                    v-model="form.attachment"
                    :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                    formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
                    class="custom-uploader--flex"
                  />
                </app-form-group>
              </template>
            </app-grid>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form.$error" type="submit" ref="submit">{{ license_to_action ? 'Update' : 'Add' }} license</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete license
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this license?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteLicense" ref="deleteEvent">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteAdministrativeLegalEntitiesLicense,
  getAdministrativeLegalEntitiesLicenses,
  getAdministrativeLicenseGroups,
  getAdministrativeSuppliers,
  getCurrencyList,
  patchAdministrativeLegalEntitiesLicense,
  postAdministrativeLegalEntitiesLicense,
} from '@/http'
import { format, parseISO } from 'date-fns'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import axios from 'axios'
import TableLicenses from '@/views/administrative/legal-entities/detail/tables/TableLicenses'
import TableLicensesExpiring from '@/views/administrative/legal-entities/detail/tables/TableLicensesExpiring'

export default {
  name: 'AdministrativeLegalEntitiesDetailLicenses',
  components: {TableLicenses, TableLicensesExpiring},
  props: {
    legalEntityData: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      page_loaded: false,
      table_expiring_items: [],
      table_licenses_items: [],
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
      form: {},
      status_filter: '',
      status_filters: [
        { value: '', label: 'All' },
        { value: 'false', label: 'Actual' },
        { value: 'true', label: 'Archive' },
      ],
      supplier_options: [],
      license_groups_options: [],
      currency_options: [],
      license_to_action: null,
    }
  },
  validations: {
    form: {
      number: { required },
      group: { required },
      type: { required },
      start: { required },
      finish: { required },
      amount_paid: { required },
      amount_paid_currency: { required },
      supplier: { required },
    }
  },
  created() {
    Promise.all([
      getAdministrativeLicenseGroups(),
      getCurrencyList(),
      this.fetchItemsExpiring(),
      this.fetchItemsLicenses(),
    ])
      .then(response => {
        this.license_groups_options = response[0].data
        this.currency_options = response[1].data
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsExpiring() {
      const response = await getAdministrativeLegalEntitiesLicenses(this.$route.params.id, { extension_required: true, car: true })
      this.table_expiring_items = response.data
    },
    async fetchItemsLicenses() {
      this.table_preloader = true
      const response = await getAdministrativeLegalEntitiesLicenses(this.$route.params.id, {
        archive: this.status_filter === 'true' ? true : this.status_filter === '' ? '' : false,
        page: this.pagination.page,
        page_size: 20,
        car: true
      })
      this.table_licenses_items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItemsLicenses()
    },
    onChangeFilter() {
      this.pagination.page = 1
      this.fetchItemsLicenses()
    },
    onOpenCreateModal(license) {
      this.license_to_action = license
      if (!license) {
        this.form = { type: '' }
      } else {
        this.form = {
          amount_paid: license.amount_paid,
          amount_paid_currency: license.amount_paid_currency,
          supplier: license.supplier,
          start: license.start,
          finish: license.finish,
          type: license.type,
          group: license.group,
          number: license.number,
          attachment: license.attachment,
        }
      }
      this.$v.form.$reset()
      this.$modal.show('create-modal')
    },
    onGroupSelected() {
      this.form.type = ''
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (!this.license_to_action) {
        postAdministrativeLegalEntitiesLicense(this.$route.params.id, this.normalizeForm())
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'License created',
            })
            this.fetchItemsExpiring()
            this.fetchItemsLicenses()
            this.$modal.hide('create-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      } else {
        patchAdministrativeLegalEntitiesLicense(this.$route.params.id, this.license_to_action.id, this.normalizeForm())
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'License updated',
            })
            this.fetchItemsExpiring()
            this.fetchItemsLicenses()
            this.$modal.hide('create-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      }
    },
    normalizeForm() {
      const normalizedForm = { ...this.form }

      normalizedForm.group = normalizedForm.group.id
      if (normalizedForm.attachment?.id) normalizedForm.attachment = normalizedForm.attachment.id
      else normalizedForm.attachment = null
      normalizedForm.supplier = normalizedForm.supplier.id
      normalizedForm.amount_paid_currency = normalizedForm.amount_paid_currency.code
      normalizedForm.type = normalizedForm.type.id

      return normalizedForm
    },
    onShowDeleteModal(id) {
      this.license_to_action = id
      this.$modal.show('delete')
    },
    onDeleteLicense() {
      this.$refs.deleteEvent.preload = true
      deleteAdministrativeLegalEntitiesLicense(this.$route.params.id, this.license_to_action)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'License deleted',
          })
          this.fetchItemsExpiring()
          this.fetchItemsLicenses()
          this.$modal.hide('delete')
        })
        .catch(() => { this.$refs.deleteEvent.preload = false })
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : ''
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
    downloadFile(doc_obj, row) {
      axios.get(doc_obj.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = doc_obj.file_name.split('.').pop()
          const part_of_name = `${row.number} - ${this.legalEntityData.name} - ${row.group.name} - ${row.type.name} - ${row.supplier.legal_name}`

          link.href = url
          link.setAttribute('download', `${part_of_name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
  }
}
</script>
